import React from "react";
import { INotificationsContext, NotificationsContext } from "./NotificationsContext";
import { withContextFactory } from "../contexts/contexts.utils";

export interface WithNotifications {
    notifications: INotificationsContext;
}

export const withNotifications = withContextFactory<WithNotifications>(NotificationsContext, "notifications");